import { createApiRef } from '@backstage/core-plugin-api';
import { Workflow, WorkflowPhase, WorkflowSummary, WorkflowTemplate, ArtifactBlob } from './types';

export interface ListWorkflowsOptions {
  namespace: string;
  labelSelector?: string;
  phases?: WorkflowPhase[];
  limit?: number;
}

export interface SubmitWorkflowOptions {
  namespace: string;
  templateName: string;
  parameters?: Record<string, string>;
  labels?: Record<string, string>;
}

export interface ArgoWorkflowsApi {
  discoverNamespaces(): Promise<string[]>;
  listWorkflows(opts: ListWorkflowsOptions): Promise<WorkflowSummary[]>;
  listWorkflowTemplates(namespace: string): Promise<WorkflowTemplate[]>;
  submitWorkflow(opts: SubmitWorkflowOptions): Promise<{ namespace: string; name: string }>;
  getWorkflow(namespace: string, name: string): Promise<Workflow>;
  resumeWorkflow(namespace: string, name: string): Promise<void>;
  stopWorkflow(namespace: string, name: string): Promise<void>;
  getArtifact(
    namespace: string,
    workflowName: string,
    nodeId: string,
    artifactName: string,
    opts?: { archivedUid?: string },
  ): Promise<ArtifactBlob>;
  getNodeLogs(
    namespace: string,
    workflowName: string,
    podName: string,
    container?: string,
  ): Promise<string>;
}

export const argoWorkflowsApiRef = createApiRef<ArgoWorkflowsApi>({
  id: 'plugin.argo-workflows.service',
});
